/* Rupee glyph in place of "Rs."

   Client, 31 Aug and again 10 Sep: "Please make sure we have the ₹ symbol
   everywhere instead of Rs."

   Every price on the site comes out of Shopify's money filter, which prints
   the store's money_format setting. That setting is "Rs. {{amount}}" and it
   lives in Settings > General > Store currency > Change formatting. A theme
   token cannot touch it, so the correct fix is one admin edit. Until that is
   made, this rewrites the rendered text.

   Scope is deliberately narrow: only "Rs" or "Rs." immediately followed by a
   digit, which is a price and nothing else. Prose that mentions rupees in
   words is left alone. Runs once on load and again on every DOM change, so
   the cart drawer, which re-renders after each add, stays correct.

   Delete this file the day money_format is changed; it will then match nothing
   and cost a MutationObserver for no reason. */
(function () {
  var RX = /\bRs\.?\s?(?=\d)/g;

  function fix(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!n.nodeValue || n.nodeValue.indexOf('Rs') === -1) return NodeFilter.FILTER_REJECT;
        var p = n.parentElement;
        if (!p) return NodeFilter.FILTER_REJECT;
        var t = p.tagName;
        if (t === 'SCRIPT' || t === 'STYLE' || t === 'TEXTAREA' || p.isContentEditable) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    for (var i = 0; i < nodes.length; i++) {
      var v = nodes[i].nodeValue;
      var w = v.replace(RX, '₹');
      if (w !== v) nodes[i].nodeValue = w;
    }
  }

  /* 6 Oct speed pass: the observer used to walk the whole body on every DOM change (about 200 ms of main thread
     per page with the carousels, tickers and Judge.me all mutating). It now fixes only the nodes that were added
     or whose text changed, batched once per frame. */
  function start() {
    fix(document.body);
    var queue = [];
    var pending = false;
    function flush() {
      pending = false;
      var q = queue; queue = [];
      for (var i = 0; i < q.length; i++) {
        var n = q[i];
        if (!n.isConnected) continue;
        if (n.nodeType === 3) { var v = n.nodeValue, w = v && v.indexOf('Rs') !== -1 ? v.replace(RX, '₹') : v; if (w !== v) n.nodeValue = w; }
        else if (n.nodeType === 1 && n.textContent && n.textContent.indexOf('Rs') !== -1) fix(n);
      }
    }
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var r = records[i];
        if (r.type === 'characterData') queue.push(r.target);
        else for (var j = 0; j < r.addedNodes.length; j++) queue.push(r.addedNodes[j]);
      }
      if (!pending && queue.length) { pending = true; requestAnimationFrame(flush); }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
